import React, { createContext, useContext } from 'react';

import { useSetSentryUserId } from '../../../logging';
import authReducer from './reducer';
import { State } from './state';
import { AuthActions, createActions } from './actions';

const initialState: State = {
  accessToken:
    typeof localStorage.getItem('accessToken') === 'string'
      ? (localStorage.getItem('accessToken') as string)
      : undefined,
  refreshToken:
    typeof localStorage.getItem('refreshToken') === 'string'
      ? (localStorage.getItem('refreshToken') as string)
      : undefined,
  profile:
    typeof localStorage.getItem('profile') === 'string'
      ? JSON.parse(localStorage.getItem('profile') as string)
      : undefined,
};

const AuthStateContext = createContext<State | null>(null);

export const useAuthState = (): State => {
  const ctx = useContext(AuthStateContext);
  if (!ctx) {
    throw new Error('useAuthState must be used within AuthProvider');
  }
  return ctx;
};

const AuthActionsContext = createContext<AuthActions | null>(null);

export const useAuthActions = (): AuthActions => {
  const ctx = useContext(AuthActionsContext);
  if (!ctx) {
    throw new Error('useauthDispatch must be used within AuthProvider');
  }
  return ctx;
};

export type AuthProviderProps = {
  children: React.ReactNode;
};

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }: AuthProviderProps): React.ReactElement => {
  const [state, dispatch] = React.useReducer(authReducer, initialState);

  useSetSentryUserId(state.accessToken);

  return (
    <AuthStateContext.Provider value={state}>
      <AuthActionsContext.Provider value={createActions(dispatch)}>{children}</AuthActionsContext.Provider>
    </AuthStateContext.Provider>
  );
};
